import store from '@/store'

export default class Authentication {
  static async auth (user: any) {
    const adminType = this.getUserAdminGroup(user)
    console.log('Authentication - adminType:', adminType)
    if (!adminType) {
      throw new AuthenticationError('NotAdminUserException')
    }
    if (!store.getters.divisionMasterLoaded) {
      await store.dispatch('loadDivisionMaster')
    }
    console.log('Authentication - isValidAdminType:', !store.getters.isValidAdminType(adminType))
    if (!store.getters.isValidAdminType(adminType)) {
      console.log('authentication - not valid admin type:', adminType)
      throw new AuthenticationError('InvalidAdminType')
    }
    store.commit('setAdminType', adminType)
    store.commit('setUser', user)
  }
  static getUserAdminGroup (user: any): string | null {
    console.log('getUserAdminGroup - user:', user)
    if (this.cognitoGroup(user) === undefined) {
      return null
    }
    const groups = this.cognitoGroup(user).filter((e: string) => {
      return e.match(/admin/g) !== null
    })
    if (groups.length > 1) {
      throw new AuthenticationError('MultipleAdminGroupAssigned')
    } else if (groups.length === 0) {
      throw new AuthenticationError('NotAdminUserException')
    } else {
      return groups[0].replace('admin-', '')
    }
  }

  private static cognitoGroup (user: any): Array<string> {
    return user.signInUserSession.accessToken.payload['cognito:groups']
  }
}

export class AuthenticationError extends Error {
  constructor (public code: string, e?: string) {
    super(e)
    this.name = new.target.name
    Object.setPrototypeOf(this, new.target.prototype)
  }
}
